/* Aisle & Roses theme script.
   Prices, variants and the cart come from Shopify. This script adds the bag drawer, the search pop-over,
   the offers shown on prices (welcome offer, own set, trade shop), the colour photos, the sets and the journal.
   Discounts are only displayed here: the real ones are Shopify discounts, applied at checkout. */
(function () {
  'use strict';
  var AR = window.AR;
  if (!AR) return;
  var D = window.ARD || { FEAT: {}, PACKS: [], JLIST: [], X: {} };
  var C = AR.cfg, U = AR.url, doc = document, root = doc.documentElement;
  var $ = function (s, r) { return (r || doc).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); };
  var layer = $('#layer');
  var esc = function (t) { return String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); };
  var store = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  var sess = {
    get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} },
    del: function (k) { try { sessionStorage.removeItem(k); } catch (e) {} }
  };
  var params = new URLSearchParams(location.search);
  var withParam = function (u, k, v) { return u + (u.indexOf('?') < 0 ? '?' : '&') + k + '=' + encodeURIComponent(v); };

  /* ---------- names ---------- */
  var CATS = {
    walls: ['Walls & backdrops', 'walls-backdrops', 'Flower walls, sequin and feather walls, curtains, swags and the stand that holds them up.'],
    arches: ['Arches & pillars', 'arches-pillars', 'Floral arches, gold frames, the rose heart and the pillars that stand either side.'],
    aisle: ['Aisle & chairs', 'aisle-chairs', 'The white runner, aisle flowers, spark fountains, lanterns, blossom trees and chair flowers.'],
    tables: ['Tables & centrepieces', 'tables-centrepieces', 'Flower runners, rose domes, candelabras and candles, linen, napkins and charger plates.'],
    display: ['Cake, plinths & display', 'cake-plinths-display', 'Plinths, pedestals and columns, cake stands and the champagne tower.'],
    signs: ['Signs, lights & keepsakes', 'signs-lights-keepsakes', 'Neon names, giant light-up letters, welcome signs, table numbers and keepsakes.']
  };
  var MOMS = {
    proposal: ['The proposal', 'proposal'], engagement: ['Engagement party', 'engagement-party'], ceremony: ['The ceremony', 'ceremony'],
    reception: ['The reception', 'reception'], hen: ['Hen party', 'hen-party']
  };
  var CATH = {}, MOMH = {};
  Object.keys(CATS).forEach(function (k) { CATH[CATS[k][1]] = k; });
  Object.keys(MOMS).forEach(function (k) { MOMH[MOMS[k][1]] = k; });
  var handleize = function (s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); };
  var main = function (t) { return String(t).split(' – ')[0]; };
  var sub = function (t) { return String(t).split(' – ').slice(1).join(' · '); };
  var purl = function (h) { return U.product + h; };
  var setUrl = function (slug) { return withParam(U.sets, 'set', slug); };
  var guideUrl = function (slug) { return withParam(U.journal, 'guide', slug); };

  /* ---------- money and offers ---------- */
  var MF = (function () {
    var f = String(AR.money || '£{{amount}}').replace(/<[^>]+>/g, ''), t = doc.createElement('textarea');
    t.innerHTML = f; f = t.value;
    var a = f.indexOf('{{'), b = f.indexOf('}}');
    return a < 0 ? ['£', ''] : [f.slice(0, a), f.slice(b + 2)];
  })();
  function money(p) {
    p = Math.round(p);
    var whole = p % 100 === 0;
    return MF[0] + (p / 100).toLocaleString('en-GB', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 }) + MF[1];
  }
  var tradeOn = function () { return !!C.tradeOn && sess.get('ar-trade') === '1'; };
  var promoOn = function () { return !!C.promoOn && !tradeOn() && !!store.get('ar-promo', false); };
  var setPromo = function (v) { store.set('ar-promo', !!v); };
  var disc = function (v) { return Math.round(v * (100 - C.promo) / 100); };
  var tr = function (v) { return Math.round(v * (100 - C.trade) / 100); };
  var ownp = function (v) { return Math.round(v * (100 - C.own) / 100); };
  var wp = function (v) { return tradeOn() ? tr(v) : promoOn() ? disc(v) : v; };
  var pct = function (full, now) { return Math.round((1 - now / full) * 100); };
  var pr = function (full, now) { return now < full ? '<s>' + money(full) + '</s> ' + money(now) + ' <span class="pct">−' + pct(full, now) + '%</span>' : money(full); };
  var count = AR.count || 0;
  var ownOn = function () { return !!C.ownOn && !tradeOn() && count >= C.ownMin; };
  function paintPrices(r) {
    $$('[data-ar-price]', r).forEach(function (el) {
      var full = +el.getAttribute('data-ar-price');
      el.innerHTML = (el.getAttribute('data-from') ? '<small>from</small> ' : '') + pr(full, wp(full));
    });
  }
  var hooks = [];
  function refresh() { paintPrices(doc); syncByo(); hooks.forEach(function (f) { f(); }); }

  /* ---------- layers ---------- */
  var lastFocus = null;
  function openLayer(node) {
    lastFocus = doc.activeElement;
    layer.innerHTML = '';
    if (typeof node === 'string') layer.innerHTML = node; else layer.appendChild(node);
  }
  function closeLayer() {
    if (!layer.firstChild) return;
    layer.innerHTML = '';
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
    lastFocus = null;
  }
  function tpl(id) { var t = $('#' + id); return t ? t.content.cloneNode(true) : null; }
  function toast(m) {
    var t = doc.createElement('div');
    t.className = 'toast'; t.setAttribute('role', 'status'); t.textContent = m;
    doc.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 2800);
  }
  function openMenu() {
    var n = tpl('ar-menu'); if (!n) return;
    openLayer(n);
    $$('[data-close]', layer).forEach(function (b) { b.addEventListener('click', closeLayer); });
    var ds = $$('details', layer);
    ds.forEach(function (d) { d.addEventListener('toggle', function () { if (d.open) ds.forEach(function (o) { if (o !== d) o.open = false; }); }); });
    var x = $('.x', layer); if (x) x.focus();
  }
  function openPromo(done, auto) {
    var n = tpl('ar-promo'); if (!n) return;
    openLayer(n);
    var no = function () { store.set('ar-pop', 1); closeLayer(); if (done) done(); };
    $$('[data-no]', layer).forEach(function (b) { b.addEventListener('click', no); });
    var f = $('#popForm', layer);
    if (f) f.addEventListener('submit', function () {
      setPromo(true); store.set('ar-pop', 1);
      sess.set('ar-toast', C.promo + '% off is applied. Code ' + C.code);
    });
    if (!auto) { var e = $('#popEmail', layer); if (e) e.focus(); }
  }
  function openLeave(target) {
    var n = tpl('ar-leave'); if (!n) { sess.del('ar-trade'); location.href = target; return; }
    openLayer(n);
    $$('[data-stay]', layer).forEach(function (b) { b.addEventListener('click', closeLayer); });
    $('[data-go]', layer).addEventListener('click', function () { sess.del('ar-trade'); location.href = target; });
    var s = $('button[data-stay]', layer); if (s) s.focus();
  }

  /* ---------- product index (for search, sets, journal) ---------- */
  var IDX = null, idxP = null;
  function prep(list) {
    var by = {};
    list.forEach(function (p) {
      p.cat = CATH[p.ty] || '';
      p.mom = (p.tg || []).map(function (t) { return MOMH[handleize(t)]; }).filter(Boolean);
      p.uk = (p.tg || []).indexOf('UK stock') >= 0;
      p.o2 = (p.o2 || []).filter(function (c) { return c !== 'None'; });
      by[p.h] = p;
    });
    return { list: list, by: by };
  }
  function getIndex() {
    if (IDX) return Promise.resolve(IDX);
    if (idxP) return idxP;
    var c = null;
    try { c = JSON.parse(sess.get('ar-index') || 'null'); } catch (e) {}
    if (c && c.v === AR.asset && c.t > Date.now() - 600000) { IDX = prep(c.d); return Promise.resolve(IDX); }
    idxP = fetch(U.index, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (t) {
      var d = JSON.parse(t);
      sess.set('ar-index', JSON.stringify({ t: Date.now(), v: AR.asset, d: d }));
      IDX = prep(d); return IDX;
    }).catch(function () { idxP = null; return prep([]); });
    return idxP;
  }
  function imgw(u, w) {
    if (!u) return '';
    if (/\/ph-[^/]+-t\.webp/.test(u)) return w > 600 ? u.replace(/-t\.webp/, '-0.webp') : u;
    if (/[?&]width=\d+/.test(u)) return u.replace(/([?&]width=)\d+/, '$1' + w);
    return u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + w;
  }
  function card(p) {
    return '<a class="card" href="' + purl(p.h) + '" data-h="' + p.h + '"><div class="arch">' + (p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(main(p.t)) + '" loading="lazy" decoding="async" width="520" height="650">' : '') + '</div>' +
      (p.uk ? '<span class="tag">UK stock</span>' : '') + '<span class="card-t">' + esc(main(p.t)) + '</span><span class="card-s">' + esc(sub(p.t)) + '</span>' +
      '<span class="price">' + (p.v1.length > 1 ? '<small>from</small> ' : '') + pr(p.p, wp(p.p)) + '</span></a>';
  }

  /* ---------- search ---------- */
  var norm = function (t) { return String(t).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, ' ').trim(); };
  var SYN = { centerpiece: 'centrepiece', centerpieces: 'centrepieces', color: 'colour', candles: 'candle', flowers: 'flower', roses: 'rose', arches: 'arch', walls: 'wall', chairs: 'chair', tables: 'table', signs: 'sign', lights: 'light', sparklers: 'sparkler', fireworks: 'sparkler', firework: 'sparkler', sparks: 'spark', neons: 'neon', arche: 'arch', rug: 'carpet', carpets: 'carpet', runners: 'runner', backdrops: 'backdrop', napkins: 'napkin', vases: 'vase', plinths: 'plinth', lanterns: 'lantern', pillars: 'pillar', trees: 'tree', letters: 'letter' };
  var normS = function (t) { return norm(t).replace(/\brose gold\b/g, 'rgold'); };
  var toks = function (q) { return normS(q).split(' ').filter(Boolean).map(function (w) { return SYN[w] || w; }); };
  var COLW = {}; 'red pink blue white black gold golden silver green purple yellow orange ivory cream beige brown grey gray burgundy blush lilac lavender navy teal turquoise coral fuchsia magenta nude khaki multicolor multicolour transparent clear rainbow iridescent bronze copper'.split(' ').forEach(function (w) { COLW[w] = 1; });
  var CATW = { table: ['tables'], tablecloth: ['tables'], centrepiece: ['tables'], backdrop: ['walls', 'arches'], wall: ['walls'], arch: ['arches'], pillar: ['arches'], aisle: ['aisle'], chair: ['aisle'], cake: ['display'], plinth: ['display'], sign: ['signs'], stand: ['display', 'walls', 'signs'] };
  var TAGS = [[/neon|\bled\b|light up|lantern|chandelier/i, 'light lights lighting'], [/neon/i, 'sign led'], [/candelabra|candle/i, 'candle candlelight']];
  var HAY = {};
  function hay(p) {
    if (HAY[p.h]) return HAY[p.h];
    var tg = TAGS.filter(function (x) { return x[0].test(p.t); }).map(function (x) { return x[1]; }).join(' ');
    var kw = (D.X[p.h] || {}).kw || '';
    return (HAY[p.h] = {
      t: normS(p.t), tt: ' ' + normS(p.t),
      kw: ' ' + normS([p.mom.map(function (m) { return MOMS[m][0]; }).join(' '), kw, tg].join(' ')),
      co: p.o2.length ? ' ' + p.o2.map(normS).join(' | ') + ' ' : ''
    });
  }
  function search(q, list) {
    var ws = toks(q); if (!ws.length) return [];
    return list.map(function (p) {
      var h = hay(p);
      var inT = ws.map(function (w) { return h.tt.indexOf(' ' + w) >= 0; });
      var ok = ws.map(function (w, i) { return inT[i] || (h.kw.indexOf(' ' + w) >= 0 && !(CATW[w] && CATW[w].indexOf(p.cat) < 0)); });
      if (h.co) ws.forEach(function (w, i) {
        if (!ok[i] && (COLW[w] || w === 'rgold') && h.co.indexOf(' ' + w) >= 0) ok[i] = true;
        if (i < ws.length - 1 && (!ok[i] || !ok[i + 1]) && h.co.indexOf(' ' + w + ' ' + ws[i + 1]) >= 0) ok[i] = ok[i + 1] = true;
      });
      if (!ok.every(Boolean)) return null;
      var s = 0;
      ws.forEach(function (w, i) { if (h.t.indexOf(w) === 0) s += 6; else if (inT[i]) s += 4; else s += 1; });
      return [s, p];
    }).filter(Boolean).sort(function (a, b) { return b[0] - a[0]; }).map(function (x) { return x[1]; });
  }
  function searchGroups(q) {
    var ws = toks(q), hit = function (t) { return ws.length && ws.every(function (w) { return (' ' + norm(t)).indexOf(' ' + w) >= 0; }); };
    var out = [];
    Object.keys(CATS).forEach(function (k) { if (hit(CATS[k][0] + ' ' + CATS[k][2])) out.push([U.shop + '/' + CATS[k][1], CATS[k][0]]); });
    Object.keys(MOMS).forEach(function (k) { if (hit(MOMS[k][0])) out.push([U.shop + '/' + MOMS[k][1], MOMS[k][0]]); });
    D.PACKS.forEach(function (k) { if (hit(k[1] + ' set pack bundle ' + k[2])) out.push([setUrl(k[0]), k[1] + ' (set)']); });
    [[U.sets, 'Complete sets', 'sets set pack packs bundle bundles'], [U.std, 'Save the date maker', 'save the date card invitation'], [U.checklist, 'Wedding checklist', 'checklist planning list'], [U.budget, 'Budget planner', 'budget cost price planner'], [U.suppliers, 'Find your suppliers', 'suppliers photographer videographer florist dj celebrant caterer planner'], [U.journal, 'Journal', 'journal guide ideas blog advice'], [U.delivery, 'Delivery & returns', 'delivery returns shipping']]
      .concat(C.tradeOn ? [[withParam(U.shop, 'trade', '1'), 'Trade shop: for professionals', 'trade professional wholesale stylist planner venue']] : [])
      .forEach(function (x) { if (x[0] && hit(x[1] + ' ' + x[2])) out.push([x[0], x[1]]); });
    return out;
  }
  var ICON = '<svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="8.5" cy="8.5" r="6"/><path d="M13 13l5 5" stroke-linecap="round"/></svg>';
  function openSearch(q0) {
    var btn = $('#searchBtn'), r = btn.getBoundingClientRect(), W = root.clientWidth, w = Math.min(340, W - 24);
    var left = Math.max(12, Math.min(r.left - 14, W - w - 12)), cx = Math.max(22, Math.min(w - 22, r.left + r.width / 2 - left));
    openLayer('<div class="spop-wrap"><div class="spop" role="dialog" aria-label="Search" style="top:' + Math.round(r.bottom + 10) + 'px;left:' + Math.round(left) + 'px;width:' + w + 'px;--cx:' + Math.round(cx) + 'px"><form class="spop-in" id="sForm" role="search">' + ICON + '<input id="sIn" type="text" inputmode="search" enterkeyhint="search" autocomplete="off" placeholder="Search: arch, flower wall, candles" aria-label="Search products"></form><div class="spop-res" id="sRes"></div></div></div>');
    var inp = $('#sIn'), res = $('#sRes'), list = [];
    var all = function (q) { return withParam(U.shop, 'q', q); };
    var paint = function () {
      var q = inp.value.trim(); if (!q) { res.innerHTML = ''; return; }
      if (!IDX) { res.innerHTML = '<p class="note" style="padding:10px 12px;text-transform:none;letter-spacing:0">Searching…</p>'; return; }
      list = search(q, IDX.list);
      res.innerHTML = list.length ? list.slice(0, 6).map(function (p) {
        return '<a class="srch-item" href="' + purl(p.h) + '">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" decoding="async">' : '<span></span>') + '<span><b>' + esc(main(p.t)) + '</b><small>' + (p.v1.length > 1 ? 'from ' : '') + money(wp(p.p)) + '</small></span></a>';
      }).join('') + (list.length > 6 ? '<a class="spop-all" href="' + all(q) + '">See all ' + list.length + ' results</a>' : '') : '<p class="note" style="padding:10px 12px;text-transform:none;letter-spacing:0">Nothing matches “' + esc(q) + '”.</p>';
    };
    inp.addEventListener('input', paint);
    if (q0) inp.value = q0;
    getIndex().then(paint);
    paint(); inp.focus();
    $('#sForm').addEventListener('submit', function (e) {
      e.preventDefault();
      var q = inp.value.trim(); if (!q) return;
      getIndex().then(function (ix) { var l = search(q, ix.list); location.href = l.length === 1 ? purl(l[0].h) : all(q); });
    });
    $('.spop-wrap', layer).addEventListener('mousedown', function (e) { if (e.target.classList.contains('spop-wrap')) closeLayer(); });
  }

  /* ---------- colour photos ---------- */
  function shot(h, size, col) {
    var X = D.X[h]; if (!X || !X.cs || !col) return '';
    var cs = X.cs, k = cs.m2 && cs.m2[size] ? cs.m2[size][col] : null;
    if (k == null) k = cs.m[col];
    if (k == null || k < 0) return '';
    var c = cs.c, x = k % c, y = Math.floor(k / c);
    return 'background-image:url(' + AR.asset + 'cr-' + cs.id + '-' + y + '.webp);background-size:' + (c * 100) + '% 100%;background-position:' + (c > 1 ? x / (c - 1) * 100 : 0) + '% 0';
  }

  /* ---------- own set bar ---------- */
  function byo(mode) {
    if (!C.ownOn || tradeOn()) return '<div data-byo="' + (mode || '') + '" hidden></div>';
    var n = count, M = C.ownMin, on = n >= M, left = M - n;
    var msg = on ? 'Your own set is on: <b>' + C.own + '% off</b> all ' + n + ' pieces.' : n ? n + ' piece' + (n > 1 ? 's' : '') + ' in your bag. Add <b>' + left + ' more</b> to make it a set and take <b>' + C.own + '% off</b>.' : 'Pick any <b>' + M + ' pieces</b>, different or the same, and they become your own set, at <b>' + C.own + '% off</b>.';
    var step = function (k, lab, s) { return '<li class="' + (n >= k ? 'on' : '') + (k === M ? ' win' : '') + '"><i>' + (k === M ? M + '+' : k) + '</i><span>' + lab + '</span><small>' + s + '</small></li>'; };
    var steps = '';
    for (var k = 1; k < M; k++) steps += step(k, k + ' piece' + (k > 1 ? 's' : ''), 'Normal price');
    steps += step(M, M + ' pieces or more', '<span class="pct">−' + C.own + '%</span> each');
    return '<div class="byo ' + (mode || '') + (on ? ' done' : '') + '" data-byo="' + (mode || '') + '">' + (mode === 'bag' ? '' : '<b class="byo-t">Build your own set</b>') +
      '<ol class="byo-steps" style="--f:' + Math.min(1, Math.max(0, (n - 1) / Math.max(1, M - 1))) + ';grid-template-columns:repeat(' + M + ',1fr)">' + steps + '</ol><p class="byo-m">' + msg + '</p></div>';
  }
  function syncByo() { $$('[data-byo]').forEach(function (e) { if (e.getAttribute('data-byo') !== 'bag') e.outerHTML = byo(e.getAttribute('data-byo')); }); }

  /* ---------- bag ---------- */
  var CART = null, bagAsk = '';
  function setCount(n) { count = n; var b = $('#bagN'); if (b) b.textContent = n; }
  function api(url, body) {
    return fetch(url + '.js', { method: body ? 'POST' : 'GET', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body ? JSON.stringify(body) : undefined })
      .then(function (r) { return r.json().catch(function () { return null; }).then(function (j) { if (!r.ok || !j) throw new Error((j && (j.description || j.message)) || 'Something went wrong. Please try again.'); return j; }); });
  }
  function getCart() { return api(U.cart).then(function (c) { CART = c; setCount(c.item_count); return c; }); }
  function bagHTML(c) {
    if (!c) return '<p class="note">Opening your bag…</p>';
    if (!c.items.length) return '<p class="lede">Your bag is empty.</p><a class="btn" href="' + U.shop + '">Shop the collection</a>';
    var trd = tradeOn(), own = ownOn(), qn = c.item_count;
    var line = function (i) { return i.original_line_price; };
    var lineNow = function (i) { return trd ? tr(line(i)) : own ? ownp(line(i)) : line(i); };
    var tot = 0, after = 0;
    c.items.forEach(function (i) { tot += line(i); after += lineNow(i); });
    var setSave = tot - after, fin = promoOn() ? disc(after) : after;
    var head = trd ? '<div class="tradenote' + (qn >= C.tradeMin ? ' ok' : '') + '"><b>Trade order</b> · ' + C.trade + '% off every piece' + (qn >= C.tradeMin ? '. Minimum of ' + C.tradeMin + ' pieces reached.' : '. Minimum ' + C.tradeMin + ' pieces: add <b>' + (C.tradeMin - qn) + ' more</b> to check out.') + '</div>' : (C.ownOn ? byo('bag') : '');
    var rows = c.items.map(function (i) {
      var X = D.X[i.handle] || {}, opts = i.product_has_only_default_variant ? [] : (i.options_with_values || []);
      if (optSwapped(opts.map(function (o) { return o.name; }))) opts = [opts[1], opts[0]];
      var size = opts[0] ? opts[0].value : '', col = opts[1] && opts[1].value !== 'None' ? opts[1].value : '';
      var st = shot(i.handle, size, col);
      var src = X.ph ? AR.asset + 'ph-' + i.handle + '-t.webp' : (i.image ? imgw(i.image, 160) : '');
      var det = opts.filter(function (o) { return o.value !== 'None'; }).map(function (o) { return '<small>' + esc(o.name) + ': ' + esc(o.value) + '</small>'; }).join('');
      var props = i.properties || {}, setName = props.Set || '';
      Object.keys(props).forEach(function (k) { if (k.charAt(0) !== '_' && k !== 'Set' && props[k]) det += '<small>' + esc(k) + ': ' + esc(props[k]) + '</small>'; });
      det += trd ? '<small style="color:var(--rose)">Trade price, ' + C.trade + '% off</small>' : own ? '<small style="color:var(--rose)">' + (setName ? 'Set: ' + esc(setName) : 'Your own set') + ', ' + C.own + '% off</small>' : (setName ? '<small>Set: ' + esc(setName) + '</small>' : '');
      var ctl = bagAsk === i.key ? '<div class="rmask" role="alert"><span>Remove this piece from your bag?</span><button type="button" class="btn sm" data-rmy="' + esc(i.key) + '">Yes, remove</button><button type="button" class="rm" data-rmn="1">No, keep it</button></div>' :
        '<div class="qty mini" role="group" aria-label="Quantity"><button type="button" data-qk="' + esc(i.key) + '" data-q="' + (i.quantity - 1) + '" aria-label="One fewer">−</button><span aria-live="polite">' + i.quantity + '</span><button type="button" data-qk="' + esc(i.key) + '" data-q="' + (i.quantity + 1) + '" aria-label="One more">+</button></div><button class="rm" type="button" data-rm="' + esc(i.key) + '">Remove</button>';
      return '<div class="ci"><a class="arch" href="' + esc(i.url) + '">' + (src ? '<img src="' + esc(src) + '" alt="">' : '') + (st ? '<div class="cshot" style="' + st + '"></div>' : '') + '</a><div><b>' + esc(main(i.product_title)) + '</b>' + det + ctl + '</div><span class="lp">' + pr(line(i), lineNow(i)) + '</span></div>';
    }).join('');
    var sums = '<div class="sum"><span>Subtotal</span><span>' + money(tot) + '</span></div>' +
      (setSave ? '<div class="sum" style="color:var(--rose)"><span>' + (trd ? 'Trade saving' : 'Set saving') + ' <span class="pct">−' + (trd ? C.trade : C.own) + '%</span></span><span>−' + money(setSave) + '</span></div>' : '') +
      (promoOn() ? '<div class="sum" style="color:var(--rose)"><span>Welcome offer, code ' + esc(C.code) + ' <span class="pct">−' + C.promo + '%</span></span><span>−' + money(after - fin) + '</span></div>' :
        (trd || !C.promoOn) ? '' : '<button class="rm" type="button" id="bagPromo" style="align-self:flex-start;color:var(--rose)">Take ' + (setSave ? 'another ' : '') + C.promo + '% off with your email' + (setSave ? ' (−' + pct(tot, disc(after)) + '% in all)' : '') + '</button>') +
      '<div class="sum"><b>Total</b><b>' + pr(tot, fin) + '</b></div>' + (fin < tot ? '<p class="saved">You save ' + money(tot - fin) + ' on this order.</p>' : '');
    return head + rows + sums + '<label for="bagNote">Order notes: your date, anything we should know<textarea id="bagNote" rows="2">' + esc(c.note || '') + '</textarea></label>' +
      '<p class="note">Prices include VAT. Delivery is calculated at checkout.' + (fin < tot ? ' Your savings are confirmed at checkout.' : '') + '</p>' +
      '<button class="btn" type="button" id="co"' + (trd && qn < C.tradeMin ? ' disabled' : '') + '>Checkout</button><p class="note" id="coMsg" role="alert"></p>';
  }
  function bagHosts() { return [$('#bagBody'), $('#arCartPage')].filter(Boolean); }
  function drawBag() { bagHosts().forEach(function (h) { h.innerHTML = bagHTML(CART); }); }
  function change(key, q) {
    return api(U.change, { id: key, quantity: q }).then(function (c) { CART = c; setCount(c.item_count); bagAsk = ''; drawBag(); syncByo(); })
      .catch(function (e) { var m = $('#coMsg'); if (m) m.textContent = e.message; });
  }
  function bagClick(e) {
    var t = e.target.closest('button'); if (!t) return;
    if (t.hasAttribute('data-qk')) {
      var q = +t.getAttribute('data-q'), key = t.getAttribute('data-qk');
      if (q < 1) { bagAsk = key; drawBag(); var y = $('[data-rmy]'); if (y) y.focus(); return; }
      change(key, Math.min(40, q));
    } else if (t.hasAttribute('data-rmy')) change(t.getAttribute('data-rmy'), 0);
    else if (t.hasAttribute('data-rmn')) { bagAsk = ''; drawBag(); }
    else if (t.hasAttribute('data-rm')) change(t.getAttribute('data-rm'), 0);
    else if (t.id === 'bagPromo') openPromo(openBag);
    else if (t.id === 'co') checkout(t);
  }
  function checkout(btn) {
    if (!CART) return;
    if (tradeOn() && CART.item_count < C.tradeMin) return;
    btn.disabled = true;
    var code = tradeOn() ? C.tradeCode : promoOn() ? C.code : '';
    var go = function () { location.href = U.checkout + (code ? '?discount=' + encodeURIComponent(code) : ''); };
    var note = $('#bagNote');
    if (note && note.value !== (CART.note || '')) api(U.update, { note: note.value }).then(go, go); else go();
  }
  function openBag() {
    openLayer('<div class="drawer" role="dialog" aria-label="Your bag"><div class="scrim" data-close></div><div class="sheet"><div class="sheet-h"><h3>Your bag</h3><button class="x" type="button" data-close>Close</button></div><div id="bagBody" style="display:flex;flex-direction:column;gap:18px"></div></div></div>');
    $$('[data-close]', layer).forEach(function (b) { b.addEventListener('click', closeLayer); });
    $('#bagBody').addEventListener('click', bagClick);
    drawBag();
    getCart().then(function () { drawBag(); syncByo(); }).catch(function () {});
    $('.x', layer).focus();
  }
  function addItems(items) {
    return api(U.add, { items: items }).then(function () { return getCart(); }).then(function (c) { syncByo(); return c; });
  }

  /* ---------- option order ----------
     The script reasons as [size, colour]. In the admin the colour option can come first:
     when it does, the product data is put back in that order here, once. */
  var COLOPT = /colou?r|design|style/i;
  function optSwapped(names) { return !!names && names.length === 2 && COLOPT.test(names[0]) && !COLOPT.test(names[1]); }
  function normP(P) {
    if (!P || P._n) return P;
    P._n = 1;
    var names = (P.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    if (optSwapped(names)) {
      P.options = [P.options[1], P.options[0]];
      (P.variants || []).forEach(function (v) { v.options = [v.options[1], v.options[0]]; var a = v.option1; v.option1 = v.option2; v.option2 = a; });
    }
    return P;
  }

  /* ---------- sets ---------- */
  var PJ = {};
  function productJs(h) {
    if (!PJ[h]) PJ[h] = fetch(purl(h) + '.js', { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('missing'); return r.json(); }).then(normP);
    return PJ[h];
  }
  var vprice = function (p, label) { for (var i = 0; i < p.v1.length; i++) if (p.v1[i][0] === label) return p.v1[i][1]; return p.p; };
  var packQty = function (k) { return k[5].reduce(function (a, x) { return a + x[2]; }, 0); };
  var packOff = function (k) { return !!C.ownOn && !tradeOn() && packQty(k) >= C.ownMin; };
  var packFull = function (k) { return k[5].reduce(function (a, x) { return a + x[2] * vprice(IDX.by[x[0]], x[1]); }, 0); };
  var packNow = function (k) { var f = packFull(k); return packOff(k) ? ownp(f) : f; };
  var packs = function () { return D.PACKS.filter(function (k) { return k[5].every(function (x) { return IDX.by[x[0]]; }); }); };
  function pcard(k) {
    var hs = k[5].map(function (x) { return x[0]; });
    hs = [hs[0]].concat(hs.slice(1).filter(function (h) { return h !== 'backdrop-stand'; }), hs.slice(1).filter(function (h) { return h === 'backdrop-stand'; }));
    var rest = hs.slice(1), full = packFull(k), now = wp(packNow(k));
    var im = function (h) { var p = IDX.by[h]; return '<img src="' + esc(p.img) + '" alt="' + esc(main(p.t)) + '" loading="lazy" decoding="async">'; };
    return '<a class="pcard" href="' + setUrl(k[0]) + '"><div class="pcard-pics">' + im(hs[0]) + '<div class="n' + rest.length + '">' + rest.map(im).join('') + '</div></div>' + (now < full ? '<span class="save">Save ' + pct(full, now) + '%</span>' : '') +
      '<span class="eyebrow">' + esc(k[2]) + '</span><h3>' + esc(k[1]) + '</h3><p>' + k[5].length + ' pieces chosen to fit together</p><span class="price">' + pr(full, now) + '</span></a>';
  }
  function packBlock(k, box) {
    var items = k[5], cols = items.map(function () { return ''; }), off = packOff(k);
    var full = packFull(k), now = wp(packNow(k)), unit = function (v) { return off ? ownp(v) : v; };
    box.innerHTML = '<div class="look-g"><div class="look-pics n' + items.length + '" style="grid-template-columns:repeat(' + items.length + ',minmax(0,1fr))">' + items.map(function (x) { var p = IDX.by[x[0]]; return '<a href="' + purl(p.h) + '"><div class="arch"><img src="' + esc(p.img) + '" alt="' + esc(main(p.t)) + '" loading="lazy" decoding="async"></div></a>'; }).join('') + '</div>' +
      '<div class="look-body"><div>' + (now < full ? '<span class="save">Set price: ' + pct(full, now) + '% off</span>' : '') + '<h3 style="margin-top:14px">' + esc(k[1]) + '</h3><p class="lede" style="margin:10px 0 18px">' + esc(k[4]) + '</p><div class="look-list">' +
      items.map(function (x, j) {
        var p = IDX.by[x[0]], v = vprice(p, x[1]);
        return '<a href="' + purl(p.h) + '"><span><b style="font-weight:500">' + (x[2] > 1 ? x[2] + ' × ' : '') + esc(main(p.t)) + '</b><small class="note" style="display:block">' + esc(x[1]) + ' · ' + esc(x[3]) + '</small>' +
          (p.o2.length ? '<select data-j="' + j + '" aria-label="' + esc(p.on[1] || 'Colour') + ' for ' + esc(main(p.t)) + '">' + p.o2.map(function (c) { return '<option>' + esc(c) + '</option>'; }).join('') + '</select>' : '') + '</span><span class="lp">' + pr(x[2] * v, wp(x[2] * unit(v))) + '</span></a>';
      }).join('') + '</div></div>' +
      '<div class="look-side"><div class="look-total"><div><b>' + pr(full, now) + '</b><small class="note" style="display:block">for the ' + packQty(k) + ' pieces, inc. VAT.' + (now < full ? ' You save ' + money(full - now) + (off && promoOn() ? ': ' + C.own + '% set price, then ' + C.promo + '% welcome offer' : '') + '.' : '') + '</small></div></div><button class="btn" type="button" data-add>Add the set to bag</button>' +
      (tradeOn() || !C.promoOn ? '' : '<p class="note">' + (promoOn() ? 'Your ' + C.promo + '% welcome offer is already included in this price.' : 'Leave your email and the ' + C.promo + '% welcome offer comes off on top: ' + money(disc(packNow(k))) + ' instead of ' + money(full) + ', <b>−' + pct(full, disc(packNow(k))) + '%</b> in all.') + '</p>') +
      '<p class="note" data-msg role="alert"></p></div></div></div>';
    $$('select', box).forEach(function (el) {
      var j = +el.getAttribute('data-j'); cols[j] = el.value;
      el.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); });
      el.addEventListener('change', function () { cols[j] = el.value; });
      productJs(items[j][0]).then(function (P) {
        var ok = P.variants.filter(function (v) { return v.option1 === items[j][1] && v.option2 && v.option2 !== 'None'; }).map(function (v) { return v.option2; });
        if (!ok.length) { el.remove(); cols[j] = ''; return; }
        el.innerHTML = ok.map(function (c) { return '<option>' + esc(c) + '</option>'; }).join(''); cols[j] = el.value;
      }).catch(function () {});
    });
    var btn = $('[data-add]', box), msg = $('[data-msg]', box);
    btn.addEventListener('click', function () {
      btn.disabled = true; msg.textContent = '';
      Promise.all(items.map(function (x) { return productJs(x[0]); })).then(function (Ps) {
        return addItems(items.map(function (x, j) {
          var vs = Ps[j].variants.filter(function (v) { return v.option1 === x[1]; });
          var v = vs.filter(function (v) { return cols[j] && v.option2 === cols[j]; })[0] || vs[0] || Ps[j].variants[0];
          return { id: v.id, quantity: x[2], properties: { Set: k[1] } };
        }));
      }).then(function () { btn.disabled = false; toast('The set is in your bag'); openBag(); })
        .catch(function (e) { btn.disabled = false; msg.textContent = e.message === 'missing' ? 'One piece of this set is not available at the moment.' : e.message; });
    });
  }
  function initLooks() {
    var tabs = $('#lookTabs'), box = $('#lookBox'); if (!tabs || !box) return;
    getIndex().then(function () {
      var H = packs().filter(function (k) { return k[3]; });
      if (!H.length) { var s = tabs.closest('section'); if (s) s.hidden = true; return; }
      var cur = 0;
      var show = function (i) { cur = i; packBlock(H[i], box); $$('.tab', tabs).forEach(function (b, j) { b.setAttribute('aria-selected', j === i ? 'true' : 'false'); }); };
      tabs.innerHTML = H.map(function (k, i) { return '<button class="tab" role="tab" type="button" data-look="' + i + '" aria-selected="false">' + esc(k[1]) + '</button>'; }).join('');
      tabs.addEventListener('click', function (e) { var b = e.target.closest('[data-look]'); if (b) show(+b.getAttribute('data-look')); });
      show(0);
      hooks.push(function () { show(cur); });
    });
  }
  function initSets() {
    var host = $('#arSets'); if (!host) return;
    var slug = params.get('set');
    getIndex().then(function () {
      var all = packs(), k = slug ? all.filter(function (x) { return x[0] === slug; })[0] : null;
      var draw = function () {
        if (!k) {
          var g = $('#arPacks'), l = $('.lede', host); if (g) g.innerHTML = all.map(pcard).join('');
          if (l && all.length && l.textContent.indexOf('Finished scenes') === 0) l.textContent = all.length + ' finished scenes' + l.textContent.slice(15);
          return;
        }
        host.innerHTML = '<div class="crumbs"><a href="' + U.home + '">Home</a> / <a href="' + U.sets + '">Complete sets</a> / ' + esc(k[1]) + '</div><div id="packBox"></div>';
        packBlock(k, $('#packBox'));
        var others = all.filter(function (x) { return x !== k && x[2] === k[2]; }).concat(all.filter(function (x) { return x !== k && x[2] !== k[2]; })).slice(0, 3);
        $('#arSetMore').innerHTML = '<section><div class="wrap"><div class="sec-head"><span class="eyebrow">More sets</span><h2>Other scenes, ready to add</h2></div><div class="packs">' + others.map(pcard).join('') + '</div></div></section>';
      };
      draw(); hooks.push(draw);
      if (k) doc.title = k[1] + ' – ' + doc.title;
    });
  }

  /* ---------- journal ---------- */
  function jcard(j) {
    var p = IDX.by[j[2]];
    return '<a class="jcard" href="' + guideUrl(j[0]) + '"><div class="arch">' + (p && p.img ? '<img src="' + esc(imgw(p.img, 720)) + '" alt="" loading="lazy" decoding="async">' : '') + '</div><h3>' + esc(j[1]) + '</h3><p>' + esc(j[3]) + '</p></a>';
  }
  function loadScript(name) {
    return new Promise(function (ok, no) { var s = doc.createElement('script'); s.src = AR.asset + name; s.onload = ok; s.onerror = no; doc.head.appendChild(s); });
  }
  function initJournalHome() {
    var host = $('#arJournalCards'); if (!host) return;
    var pick = ($('#arJournalHome').getAttribute('data-pick') || '').split(',').map(function (s) { return s.trim(); });
    getIndex().then(function () {
      var js = pick.map(function (s) { return D.JLIST.filter(function (j) { return j[0] === s; })[0]; }).filter(Boolean);
      if (!js.length) js = D.JLIST.slice(0, 3);
      host.innerHTML = js.map(jcard).join('');
      if (!js.length) $('#arJournalHome').hidden = true;
    });
  }
  function initJournal() {
    var host = $('#arJournal'); if (!host) return;
    var slug = params.get('guide'), J = D.JLIST;
    getIndex().then(function () {
      var j = slug ? J.filter(function (x) { return x[0] === slug; })[0] : null;
      if (!j) { $('#arJournalList').innerHTML = J.map(jcard).join(''); return; }
      var k = J.indexOf(j), nx = [J[(k + 1) % J.length], J[(k + 2) % J.length], J[(k + 3) % J.length]], p = IDX.by[j[2]];
      doc.title = j[1] + ' – ' + doc.title;
      host.innerHTML = '<div class="crumbs"><a href="' + U.home + '">Home</a> / <a href="' + U.journal + '">Journal</a></div><div class="art"><div><h1>' + esc(j[1]) + '</h1><div class="prose" id="arGuide"><p class="lede">' + esc(j[3]) + '</p></div></div>' + (p && p.img ? '<div class="art-pic"><div class="arch"><img src="' + esc(imgw(p.img, 1100)) + '" alt=""></div></div>' : '') + '</div>';
      $('#arJournalMore').innerHTML = '<section id="arGuideP" hidden><div class="wrap"><div class="sec-head"><span class="eyebrow">In this guide</span><h2>The pieces we mentioned</h2></div><div class="grid"></div></div></section><section style="padding-top:0"><div class="wrap"><div class="sec-head"><span class="eyebrow">Keep reading</span><h2>More from the journal</h2></div><div class="journal">' + nx.map(jcard).join('') + '</div></div></section>';
      loadScript('ar-journal.js').then(function () {
        var g = (window.ARJ || {})[slug]; if (!g) return;
        $('#arGuide').insertAdjacentHTML('beforeend', g[0].map(function (t) { return '<p>' + esc(t) + '</p>'; }).join(''));
        var ps = g[1].map(function (h) { return IDX.by[h]; }).filter(Boolean);
        if (ps.length) { var s = $('#arGuideP'); s.hidden = false; $('.grid', s).innerHTML = ps.map(card).join(''); }
      }).catch(function () {});
    });
  }

  /* ---------- shop ---------- */
  function initShop() {
    var box = $('#arShop'); if (!box) return;
    var grid = $('#shopGrid'), cards = $$('.card', grid), inp = $('#shopQ'), clr = $('#shopClr'), sortEl = $('#sort');
    var trade = tradeOn(), build = root.classList.contains('is-build');
    var cat = CATH[box.getAttribute('data-cat')] || '', mom = MOMH[box.getAttribute('data-mom')] || '';
    var title = box.getAttribute('data-title'), scope = cat || mom ? 'in ' + title : '';
    if (trade || build) $$('.filters a.chip', box).forEach(function (a) { a.setAttribute('href', withParam(a.getAttribute('href'), trade ? 'trade' : 'build', '1')); });
    var byH = {}; cards.forEach(function (c) { byH[c.getAttribute('data-h')] = c; });
    var price = function (c) { return +c.getAttribute('data-p'); };
    function featured(list) {
      var by = {}, order = Object.keys(D.FEAT), out = [], rest = [], go = true;
      order.forEach(function (c) { by[c] = []; });
      order.forEach(function (c) { D.FEAT[c].forEach(function (h) { var el = byH[h]; if (el && list.indexOf(el) >= 0) by[c].push(el); }); });
      list.forEach(function (el) { var c = CATH[el.getAttribute('data-cat')]; if (!c || !by[c]) rest.push(el); else if (by[c].indexOf(el) < 0) by[c].push(el); });
      while (go) { go = false; order.forEach(function (c) { var el = by[c].shift(); if (el) { out.push(el); go = true; } }); }
      return out.concat(rest);
    }
    var sort = sess.get('ar-sort') || 'featured';
    if (sortEl) sortEl.value = sort;
    function draw() {
      var q = inp ? inp.value.trim() : '', all = null, list;
      if (q && IDX) { all = search(q, IDX.list); list = all.map(function (p) { return byH[p.h]; }).filter(Boolean); }
      else if (q) { getIndex().then(draw); return; }
      else list = cards.slice();
      if (!q && sort === 'featured') list = featured(list);
      if (sort === 'low') list = list.slice().sort(function (a, b) { return price(a) - price(b); });
      if (sort === 'high') list = list.slice().sort(function (a, b) { return price(b) - price(a); });
      cards.forEach(function (c) { c.hidden = true; });
      list.forEach(function (c) { c.hidden = false; grid.appendChild(c); });
      if (clr) clr.hidden = !q;
      $('#shopCount').textContent = list.length + ' ' + (list.length === 1 ? 'piece' : 'pieces') + (trade ? ' at trade price' + (cat ? ' in ' + title : '') : q ? ' for “' + q + '”' + (scope ? ' ' + scope : '') : '');
      var also = q ? searchGroups(q).filter(function (x) { return x[0] !== location.pathname; }) : [];
      $('#shopAlso').innerHTML = also.length ? '<div class="filters" style="margin-bottom:0"><span class="note">See also</span>' + also.slice(0, 6).map(function (x) { return '<a class="chip" href="' + esc(x[0]) + '">' + esc(x[1]) + '</a>'; }).join('') + '</div>' : '';
      var others = q && (cat || mom) ? all.length - list.length : 0, more = withParam(U.shop, 'q', q);
      if (cards.length) $('#shopNone').innerHTML = q && !list.length ? '<p class="lede" style="margin-top:8px">Nothing ' + (scope || 'in the collection') + ' matches “' + esc(q) + '”. ' + (others ? '' : 'Try a simpler word, such as arch, wall, candles or roses.') + '</p>' + (others ? '<p style="margin-top:14px"><a class="btn ghost" href="' + more + '">See ' + others + ' ' + (others === 1 ? 'match' : 'matches') + ' in the whole collection</a></p>' : '') : (others ? '<p style="margin-top:28px"><a class="link" href="' + more + '">' + others + ' more ' + (others === 1 ? 'match' : 'matches') + ' in the whole collection</a></p>' : '');
    }
    if (inp) {
      var q0 = params.get('q'); if (q0 && !trade) inp.value = q0.slice(0, 60);
      inp.addEventListener('input', draw);
      inp.addEventListener('focus', function () { getIndex(); }, { once: true });
      $('#shopS').addEventListener('submit', function (e) { e.preventDefault(); inp.blur(); });
      clr.addEventListener('click', function () { inp.value = ''; draw(); inp.focus(); });
    }
    if (sortEl) sortEl.addEventListener('change', function () { sort = sortEl.value; sess.set('ar-sort', sort); draw(); });
    draw();
  }

  /* ---------- product ---------- */
  function initProduct() {
    var el = $('#arProduct'); if (!el) return;
    var P; try { P = normP(JSON.parse(el.textContent)); } catch (e) { return; }
    var X = D.X[P.handle] || {}, form = $('#arBuy'), idIn = $('#arVariant'), groups = $$('.ar-opt', form).sort(function (a, b) { return a.getAttribute('data-oi') - b.getAttribute('data-oi'); }), pMain = $('#pMain'), cShot = $('#cShot');
    var byId = {}; P.variants.forEach(function (v) { byId[v.id] = v; });
    var start = byId[idIn.value] || P.variants[0], sel = start.options.slice(), picked = false, baseSrc = pMain ? pMain.getAttribute('src') : '';
    if (X.ref && !params.get('variant') && P.variants.some(function (v) { return v.options[0] === X.ref; })) sel[0] = X.ref;
    var valid = function (oi, val) { return P.variants.some(function (v) { for (var k = 0; k < oi; k++) if (v.options[k] !== sel[k]) return false; return v.options[oi] === val; }); };
    var values = function (oi) { var seen = {}, out = []; P.variants.forEach(function (v) { var x = v.options[oi]; if (!seen[x]) { seen[x] = 1; out.push(x); } }); return out; };
    var fix = function () { for (var oi = 1; oi < sel.length; oi++) if (!valid(oi, sel[oi])) sel[oi] = values(oi).filter(function (x) { return valid(oi, x); })[0]; };
    var cur = function () { return P.variants.filter(function (v) { return v.options.every(function (o, k) { return o === sel[k]; }); })[0] || P.variants[0]; };
    var q = $('#qv'), add = $('#addBtn'), ck = $('#promoCk'), msg = $('#addMsg');
    if (X.sw && groups[1]) {
      var g = $('.opts', groups[1]); g.className = 'sw';
      $$('button', g).forEach(function (b) { var c = b.getAttribute('data-v'); b.className = ''; b.title = c; b.setAttribute('aria-label', c); if (X.sw[c]) b.innerHTML = '<img src="' + AR.asset + X.sw[c] + '" alt="" loading="lazy" decoding="async">'; });
    }
    var tx = X.tx || null, single = tx && tx[1] === 1, txIn = null, txCnt = null;
    var maxL = function () { if (tx[1]) return tx[1]; var m = String(sel[0]).match(/-(\d+) letters/); return m ? +m[1] : 14; };
    if (tx) {
      $('#arTx').innerHTML = '<label for="neonTxt">' + esc(tx[0]) + '<input id="neonTxt" name="properties[' + (single ? 'Letter' : 'Wording') + ']" autocomplete="off" placeholder="' + esc(tx[2]) + '"' + (single ? ' style="max-width:8em"' : '') + '><span class="note" id="neonCnt" style="text-transform:none;letter-spacing:0"></span></label>';
      txIn = $('#neonTxt'); txCnt = $('#neonCnt');
    }
    function paint() {
      fix();
      var v = cur(), full = v.price;
      idIn.value = v.id;
      $('#pPrice').innerHTML = tradeOn() ? pr(full, tr(full)) + '<small>inc. VAT · trade price, minimum order ' + C.tradeMin + ' pieces</small>' : promoOn() ? pr(full, disc(full)) + '<small>inc. VAT · ' + C.promo + '% welcome offer applied</small>' : money(full) + '<small>inc. VAT</small>';
      if (ck) ck.checked = promoOn();
      groups.forEach(function (gr) {
        var oi = +gr.getAttribute('data-oi'), shown = 0;
        $$('button[data-v]', gr).forEach(function (b) {
          var val = b.getAttribute('data-v'), ok = valid(oi, val) && val !== 'None';
          b.hidden = !ok; if (ok) shown++;
          b.setAttribute('aria-pressed', val === sel[oi] ? 'true' : 'false');
        });
        gr.hidden = oi > 0 && !shown;
        var nm = $('.ar-optname', gr); if (nm) nm.textContent = sel[oi];
      });
      var col = sel[1] && sel[1] !== 'None' ? sel[1] : '';
      if (cShot) {
        var st = picked && col ? shot(P.handle, sel[0], col) : '';
        cShot.hidden = !st; if (st) cShot.style.cssText = st;
        if (picked && col && !st && v.featured_image && pMain) pMain.src = imgw(v.featured_image.src, 1100);
        if (picked && col) $$('.thumb').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      }
      if (txIn) {
        txIn.maxLength = maxL();
        if (txIn.value.length > maxL()) txIn.value = txIn.value.slice(0, maxL());
        if (single) txIn.value = txIn.value.toUpperCase().replace(/[^A-Z&]/g, '');
        txCnt.textContent = single ? 'One letter per item: A to Z, or &. To spell a word, add each letter to your bag in turn. Your letter is printed on the order.' : txIn.value.length + ' of ' + maxL() + ' characters at this width, spaces included. Your wording is printed on the order.';
      }
      add.disabled = !v.available; add.textContent = v.available ? 'Add to bag' : 'Sold out';
      if (history.replaceState && sel.join('|') !== start.options.join('|')) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u); }
    }
    groups.forEach(function (gr) {
      var oi = +gr.getAttribute('data-oi');
      gr.addEventListener('click', function (e) { var b = e.target.closest('button[data-v]'); if (!b) return; sel[oi] = b.getAttribute('data-v'); if (oi > 0) picked = true; paint(); });
    });
    $('#qm').addEventListener('click', function () { q.value = Math.max(1, (+q.value || 1) - 1); });
    $('#qp').addEventListener('click', function () { q.value = Math.min(40, (+q.value || 1) + 1); });
    $$('.thumb').forEach(function (b) {
      b.addEventListener('click', function () { picked = false; if (cShot) cShot.hidden = true; pMain.src = b.getAttribute('data-src'); $$('.thumb').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); });
    });
    if (txIn) txIn.addEventListener('input', paint);
    if (ck) ck.addEventListener('change', function () { if (ck.checked) { if (!promoOn()) openPromo(refresh); } else { setPromo(false); refresh(); } });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var props = {};
      if (txIn) {
        var t = txIn.value.trim();
        if (!t) { txCnt.textContent = single ? 'Type the letter you need before adding it to your bag.' : 'Type the wording for your sign before adding it to your bag.'; txIn.focus(); return; }
        props[single ? 'Letter' : 'Wording'] = t;
      }
      var n = Math.max(1, Math.min(40, +q.value || 1)), item = { id: +idIn.value, quantity: n };
      if (txIn) item.properties = props;
      add.disabled = true; msg.hidden = true;
      addItems([item]).then(function (c) {
        add.disabled = false;
        var k = c.item_count, M = C.ownMin;
        toast(!C.ownOn || tradeOn() ? 'Added to your bag' : k >= M ? 'Added. Your own set: ' + C.own + '% off' : 'Added. ' + (M - k) + ' more piece' + (M - k > 1 ? 's' : '') + ' for ' + C.own + '% off');
        openBag();
      }).catch(function (err) { add.disabled = false; msg.hidden = false; msg.textContent = err.message; });
    });
    var fl = $('#arFlowers');
    if (fl) fl.textContent = X.real || (/flower|floral|rose|pampas|greenery|blossom|feather|bouquet/i.test(P.title) && !/rose gold/i.test(P.title) ? 'Artificial, reusable' : 'Not applicable');
    var ins = D.PACKS.filter(function (k) { return k[5].some(function (x) { return x[0] === P.handle; }); }).slice(0, 2), inEl = $('#arInSets');
    if (ins.length && inEl) { inEl.hidden = false; inEl.innerHTML = 'Part of ' + ins.map(function (k) { return '<a href="' + setUrl(k[0]) + '">' + esc(k[1]) + '</a>'; }).join(' and ') + (C.ownOn ? ': buy the set and save ' + C.own + '%.' : '.'); }
    paint(); hooks.push(paint);
    if (pMain) pMain.addEventListener('load', function () { $$('.thumb').slice(1).forEach(function (b) { new Image().src = b.getAttribute('data-src'); }); }, { once: true });
    getIndex().then(function (ix) {
      var p = ix.by[P.handle]; if (!p) return;
      var rel = ix.list.filter(function (x) { return x.h !== p.h && x.cat !== p.cat && x.mom.some(function (m) { return p.mom.indexOf(m) >= 0; }); });
      var pick = ['aisle', 'arches', 'walls', 'tables', 'display', 'signs'].filter(function (c) { return c !== p.cat; }).map(function (c) {
        var f = (D.FEAT[c] || []).map(function (h) { return rel.filter(function (x) { return x.h === h; })[0]; }).filter(Boolean);
        return f[0];
      }).filter(Boolean).slice(0, 4);
      if (!pick.length) return;
      var drawLook = function () { $('#arLook').innerHTML = pick.map(card).join(''); };
      drawLook(); hooks.push(drawLook); $('#arLookSec').hidden = false;
    });
  }

  /* ---------- where the visitor came from ---------- */
  function trail() {
    var here = location.pathname + location.search, t = [];
    try { t = JSON.parse(sess.get('ar-trail') || '[]'); } catch (e) {}
    var label = 'where you were', h1 = $('#view h1');
    if (AR.tpl === 'index') label = 'the home page';
    else if (AR.tpl === 'product') label = h1 ? h1.textContent : label;
    else if (AR.key === 'sets') label = params.get('set') ? 'the set' : 'the sets';
    else if (AR.key === 'journal') label = params.get('guide') ? 'the guide' : 'the journal';
    else if (AR.tpl === 'collection' && !AR.key) { var b = $('#arShop'); label = params.get('q') ? 'your results' : tradeOn() ? 'the trade shop' : b && (b.getAttribute('data-cat') || b.getAttribute('data-mom')) ? b.getAttribute('data-title') : 'the collection'; }
    if (t.length > 1 && t[t.length - 2].u === here) t.pop();
    else if (!t.length || t[t.length - 1].u !== here) t.push({ u: here, t: label });
    if (t.length > 40) t.shift();
    sess.set('ar-trail', JSON.stringify(t));
    if (AR.tpl !== 'product' || t.length < 2) return;
    var prev = t[t.length - 2], a = $('#arBack');
    var back = function (e) {
      var ref = ''; try { var r = new URL(doc.referrer); ref = r.origin === location.origin ? r.pathname + r.search : ''; } catch (x) {}
      if (ref === prev.u && history.length > 1) { e.preventDefault(); history.back(); }
    };
    if (a) { a.hidden = false; a.href = prev.u; a.textContent = '← Back to ' + prev.t; a.addEventListener('click', back); }
    var pill = doc.createElement('a');
    pill.className = 'backpill'; pill.href = prev.u; pill.textContent = '← Back'; pill.setAttribute('aria-label', 'Back to ' + prev.t);
    pill.addEventListener('click', back);
    $('#view').appendChild(pill);
  }

  /* ---------- start ---------- */
  function start() {
    var burger = $('#burger'), sb = $('#searchBtn'), bb = $('#bagBtn');
    if (burger) burger.addEventListener('click', openMenu);
    if (sb) sb.addEventListener('click', function (e) { e.preventDefault(); openSearch(); });
    if (bb) bb.addEventListener('click', function (e) { if (AR.tpl === 'cart') return; e.preventDefault(); openBag(); });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLayer(); });
    var ex = $('#tradeExit'); if (ex) ex.addEventListener('click', function () { sess.del('ar-trade'); });
    doc.addEventListener('click', function (e) {
      if (!tradeOn()) return;
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || a.id === 'tradeExit' || a.getAttribute('role') === 'button' || a.target === '_blank') return;
      var u; try { u = new URL(a.href, location.href); } catch (x) { return; }
      if (u.origin !== location.origin) return;
      if (u.pathname.indexOf('/products/') >= 0) return;
      if (u.pathname.indexOf(U.shop) === 0 && u.searchParams.get('trade') === '1') return;
      if (u.pathname === location.pathname && u.search === location.search) return;
      e.preventDefault(); e.stopPropagation();
      openLeave(u.href);
    }, true);

    if (tradeOn() || promoOn()) paintPrices(doc);
    syncByo();
    initProduct(); initShop(); initLooks(); initSets(); initJournalHome(); initJournal();

    var page = $('#arCartPage');
    if (page) { page.addEventListener('click', bagClick); drawBag(); getCart().then(function () { drawBag(); }).catch(function () { page.innerHTML = ''; }); }
    else getCart().then(function () { syncByo(); }).catch(function () {});

    var news = $('#news');
    if (news) news.addEventListener('submit', function () { var d = $('#newsDate'), t = $('#newsTags'); if (d && d.value && t) t.value = 'newsletter, wedding date ' + d.value; });
    var sup = $('#supForm');
    if (sup) sup.addEventListener('submit', function (e) {
      var needs = $$('[data-need]:checked', sup).map(function (i) { return i.value; });
      if (!needs.length) { e.preventDefault(); $('#supMsg').textContent = 'Tick at least one supplier you are looking for.'; return; }
      $('#supNeeds').value = needs.join(', ');
    });

    var t = sess.get('ar-toast'); if (t) { sess.del('ar-toast'); toast(t); }
    if (C.promoOn && C.popup && !store.get('ar-pop', 0) && !promoOn() && !tradeOn() && AR.tpl !== 'cart') setTimeout(function () { if (!layer.firstChild && !tradeOn()) openPromo(null, true); }, 1400);
    trail();
  }
  window.ARTheme = { money: money, openBag: openBag, store: store };
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start); else start();
})();
